import { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { websiteLink } from "../../helpers/helpers";
import { useSelector } from "react-redux";
import * as paths from "../../constants/paths";
import Cookies from "js-cookie";
import DashNav from "./DashNav";
import Navigation from "./Navigation";
import Sidebar from "./Sidebar";

export default function Header({ siteSettings, logged = false }) {
  const [scroll, setScroll] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [dropDownOne, setDropDownOne] = useState(false);
  const dropOneRef = useRef(null);

  const ToggleActive = () => {
    setToggle(!toggle);
  };

  const firstDropdown = () => {
    setDropDownOne(!dropDownOne);
  };

  // Close dropdown when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropOneRef.current && !dropOneRef.current.contains(event.target)) {
        setDropDownOne(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const location = useLocation();
  const pathname = location.pathname;

  // Define the pages that should use the 'contain' class
  const specialPages = [
    "/",
    "/signin/",
    "/signin",
    "/signup",
    "/forgot-password",
    "/verify-email",
    "/subscription",
  ];
  // const isSpecialPage = specialPages.includes(pathname);
  const isSpecialPage = specialPages.includes(pathname) || pathname.startsWith("/email-verify");
  const containerClass = specialPages.includes(location.pathname)
    ? "contain"
    : "contain-fluid";
  return (
    <>
      {isSpecialPage && !logged ? (
        <header className={scroll ? "header_main fix" : "header_main"}>
          <div className="contain">
            <div className="logo">
              <Link to={paths.PUBLIC_SITE_URL}>
                <img src={paths.SITE_BASE_URL + "/images/new/logo1.svg"} />
              </Link>
            </div>
            <div
              className="togle_option"
              onClick={firstDropdown}
              ref={dropOneRef}
            >
              <Link to="/signin" className="tog_opt">
                <button
                  type="button"
                  className={!toggle ? "toggle" : "toggle active"}
                >
                  <span></span>
                </button>
                <div className="_img">
                  <img
                    src={paths.SITE_BASE_URL + "/images/new/frame.svg"}
                    alt=""
                  />
                </div>
              </Link>
              {/* <div className={dropDownOne ? "drop_sub active" : "drop_sub"}>
                <ul>
                  <li>
                    <Link to="/signin" className="site_btn">
                      Sign in
                    </Link>
                  </li>
                  <li>
                    <Link to="/signup" className="site_btn">
                      Sign up
                    </Link>
                  </li>
                </ul>
              </div> */}
            </div>

            <Navigation active={toggle} toggle={ToggleActive} logged={false} />
            <div className="faq_link_btn">
              <NavLink className="" to={paths.faqs_link}>
                <img
                  src={paths.SITE_BASE_URL + "/images/nav-faq.svg"}
                  alt="doucment image"
                />
              </NavLink>
            </div>
            <div className="clearfix"></div>
          </div>
          {toggle ? (
            <Sidebar
              active={toggle}
              toggle={ToggleActive}
              className={!toggle ? "" : "active"}
            />
          ) : (
            ""
          )}
        </header>
      ) : (
        <header className="logged_header">
          <div className="contain">
            <div className="logo">
              <Link to={paths.PUBLIC_SITE_URL}>
                <img src={paths.SITE_BASE_URL + "/images/new/logo1.svg"} />
              </Link>
            </div>

            <DashNav />
            <div className="faq_link_btn logged">
              <NavLink className="" to={paths.faqs_link}>
                <img
                  src={paths.SITE_BASE_URL + "/images/nav-faq.svg"}
                  alt="doucment image"
                />
              </NavLink>
            </div>
            <div className="clearfix"></div>
          </div>
        </header>
      )}
    </>
  );
}
